export { default as MedScoutMapsProvider } from './MedScoutMapsProvider';
